import React, { useEffect, useState } from "react";
import CardReview from "../../components/cards/CardReview";
import ProfileTabs from "../../components/ProfileTabs";
import { useAtom } from "jotai";
import { userAtom } from "../../store";
import { getUserRating, getUserReviews } from "../../firebase/users";
import ProfileTitle from "../../components/ProfileTitle";


const RatingAndReviews = () => {
  const [userData, setUserData] = useAtom(userAtom)
  const [loading, setLoading] = useState(true)
  const [reviews, setReviews] = useState([])
  const [ratings, setRatings] = useState(0)
  const [showCounts, setShowCounts] = useState(3)
  const [countsByRating, setCountsByRating] = useState(null)

  useEffect(() => {
    if (userData) {
      getUserReviews(userData.id).then((data) => {
        setReviews(data.reviews)
        setCountsByRating(data.countsByRating)
      })

      getUserRating(userData.id).then((data) => {
        setRatings(data)
      })
    }
  }, [userData])

  return (
    <>
      <div>
        <ProfileTitle />

        <ProfileTabs activeTab="Ratings And Reviews" />

        {reviews.length > 0 ?
          <>
            <div className="lg:flex justify-between gap-6 mt-9">
              <span className="block uppercase text-primary text-[12px] max-lg:mb-8">Ratings and Reviews</span>
            </div>

            <div className="flex flex-col lg:flex-row gap-6 lg:gap-20 mt-12">
              <div className="lg:hidden max-w-[270px]">
                <h4 className="font-aero text-[32px] lg:text-[48px] uppercase text-white">
                  {ratings.toFixed(1)}
                </h4>
                <div className="flex items-center">
                  <img
                    src="/assets/icons/icon-star-fill.svg"
                    className="w-[14px] lg:w-[28px]"
                  />
                  <img
                    src="/assets/icons/icon-star-fill.svg"
                    className="w-[14px] lg:w-[28px]"
                  />
                  <img
                    src="/assets/icons/icon-star-fill.svg"
                    className="w-[14px] lg:w-[28px]"
                  />
                  <img
                    src="/assets/icons/icon-star-fill.svg"
                    className="w-[14px] lg:w-[28px]"
                  />
                  <img
                    src="/assets/icons/icon-star-fill.svg"
                    className="w-[14px] lg:w-[28px]"
                  />
                </div>
                <span className="block text-lg text-white whitespace-nowrap mt-1">
                  Based on {reviews.length} Reviews
                </span>
              </div>

              <div className="md:w-[400px] w-full max-w-full flex items-center gap-6">
                <div className="w-full max-w-full space-y-2 md:space-y-4">
                  {
                    [4, 3, 2, 1, 0].map((item) =>
                      <div className="flex justify-between items-center gap-3" key={`rating-${item}`}>
                        <div className="flex items-center">
                          <span className="text-white text-xs md:text-xl inline-block mr-5 md:mr-7">
                            {item + 1}
                          </span>
                          <img
                            src="/assets/icons/icon-star-fill-white.svg"
                            className="max-w-[14px] md:max-w-[unset] absolute left-8 md:left-10"
                          />
                        </div>
                        <div className="relative w-full h-[8px] md:max-w-[340px] bg-white left-0">
                          <div className="absolute top-0 left-0 h-full bg-primary" style={{ width: (countsByRating[item] * 100) / reviews.length + '%' }}></div>
                        </div>
                      </div>
                    )
                  }
                </div>
              </div>

              <div className="hidden lg:block max-w-[270px]">
                <h4 className="font-aero text-[32px] lg:text-[48px] uppercase text-white">
                  {ratings.toFixed(1)}
                </h4>
                <div className="flex items-center">
                  {
                    [1, 2, 3, 4, 5].map(item =>
                      <img
                        src="/assets/icons/icon-star-fill.svg"
                        className="w-[14px] lg:w-[28px]"
                        key={`star-${item}`}
                      />
                    )
                  }
                </div>
                <span className="block text-lg text-white whitespace-nowrap mt-1">
                  Based on {reviews.length} Reviews
                </span>
              </div>
              {/*  */}
            </div>
          </>
          :
          <div className="text-white text-lg text-center mt-8">No reviews yet</div>
        }
      </div>

      <div className="mt-14">

        <div className="grid grid-cols-1 lg:grid-cols-3 lg:mt-32 gap-5">
          {reviews.slice(0, showCounts).map((review) => (
            <CardReview
              key={review.id}
              rating={review.rating}
              timeAgo={review.created_at}
              title={review.title}
              description={review.description}
              username={review.reviewer_name}
            />
          ))}
        </div>

        {
          reviews.length > showCounts ?
            <div className="w-full lg:w-fit mx-auto mt-8 lg:mt-16">
              <button className="text-white text-sm underline" onClick={() => setShowCounts(showCounts + 3)}>
                View More
              </button>
            </div>
            : ""
        }
      </div>
    </>
  );
};

export default RatingAndReviews;
